(function () {
  'use strict';

  var data = window.marlaProductData;
  if (!data) return;

  var variants   = data.variants;
  var threshold  = data.priceThresholdCents;

  var variantInput   = document.getElementById('marla-pdp-variant-id');
  var priceEl        = document.getElementById('marla-pdp-price');
  var railPriceEl    = document.getElementById('marla-pdp-rail-price');
  var metalLabelEl   = document.getElementById('marla-pdp-metal-label');
  var metalValEl     = document.getElementById('marla-pdp-metal-val');
  var ctaRow         = document.getElementById('marla-pdp-cta-row');
  var ctaRowRail     = document.getElementById('marla-pdp-rail-cta-row');
  var buyBtn         = document.getElementById('marla-pdp-buy-btn');
  var railBuyBtn     = document.getElementById('marla-pdp-rail-buy-btn');

  // One slot per option position, indexed by option order
  var selectedOptions = [];

  function init() {
    document.querySelectorAll('.marla-pdp__select').forEach(function (sel) {
      var idx = parseInt(sel.dataset.optionIndex, 10);
      if (sel.value) selectedOptions[idx] = sel.value;
    });
    document.querySelectorAll('.marla-pdp__swatch[aria-pressed="true"]').forEach(function (sw) {
      var idx = parseInt(sw.dataset.optionIndex, 10);
      selectedOptions[idx] = sw.dataset.value;
    });
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return !selectedOptions[i] || opt === selectedOptions[i];
      });
    }) || variants[0];
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toLocaleString('en-GB', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function updateUI(variant) {
    if (!variant) return;

    if (variantInput) variantInput.value = variant.id;

    var priceStr = (data.priceMin !== data.priceMax ? 'From ' : '') + formatMoney(variant.price);
    if (priceEl) priceEl.textContent = priceStr;

    var metal = selectedOptions[0] || (metalLabelEl ? metalLabelEl.textContent : '');
    if (railPriceEl) railPriceEl.textContent = priceStr + (metal ? ' · ' + metal : '');

    if (!data.hasOnlyDefaultVariant) {
      if (metalLabelEl && variant.option1) metalLabelEl.textContent = variant.option1;
      if (metalValEl   && variant.option1) metalValEl.textContent   = variant.option1;
    }

    var enquiryOnly = variant.price >= threshold;
    if (ctaRow)     ctaRow.classList.toggle('marla-pdp__cta-row--enquiry-only', enquiryOnly);
    if (ctaRowRail) ctaRowRail.classList.toggle('marla-pdp__cta-row--enquiry-only', enquiryOnly);

    var available = variant.available && !enquiryOnly;
    if (buyBtn)     buyBtn.disabled = !available;
    if (railBuyBtn) railBuyBtn.disabled = !available;
  }

  function updateImages(metalValue) {
    if (!data.media || !data.media.length) return;
    var metal = metalValue.toLowerCase();

    // Find first matching media for the hero
    var heroMedia = null;
    var heroIndex = -1;
    for (var i = 0; i < data.media.length; i++) {
      var m = data.media[i];
      if (m.alt && m.alt.toLowerCase().indexOf(metal) !== -1) {
        heroMedia = m;
        heroIndex = i;
        break;
      }
    }
    if (!heroMedia) return; // product has no alt-tagged images — leave as-is

    // Swap hero image
    var heroImg = document.querySelector('.marla-pdp__hero-img');
    if (heroImg) {
      heroImg.src    = heroMedia.src;
      heroImg.srcset = heroMedia.srcset;
      heroImg.alt    = heroMedia.alt || '';
    }

    // Show/hide gallery items — hide the one already in the hero, show the rest of the metal.
    // The gallery starts at media[1] (media[0] is only ever the hero), so item i is data.media[i + 1].
    // Match by position, not alt text: variant images often share identical alts.
    document.querySelectorAll('.marla-pdp__gallery-item').forEach(function (item, i) {
      var itemAlt      = (item.dataset.mediaAlt || '').toLowerCase();
      var matchesMetal = itemAlt.indexOf(metal) !== -1;
      var isHero       = (i + 1) === heroIndex;
      item.style.display = (matchesMetal && !isHero) ? '' : 'none';
    });
  }

  // Metal swatch clicks
  document.querySelectorAll('.marla-pdp__swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var idx = parseInt(sw.dataset.optionIndex, 10);
      selectedOptions[idx] = sw.dataset.value;
      sw.closest('.marla-pdp__swatches').querySelectorAll('.marla-pdp__swatch').forEach(function (s) {
        s.setAttribute('aria-pressed', s === sw ? 'true' : 'false');
      });
      if (metalValEl) metalValEl.textContent = sw.dataset.value;
      updateUI(findVariant());
      updateImages(sw.dataset.value);
    });
  });

  // Select changes
  document.querySelectorAll('.marla-pdp__select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var idx = parseInt(sel.dataset.optionIndex, 10);
      selectedOptions[idx] = sel.value;
      updateUI(findVariant());
    });
  });

  // Rail buy button submits the main form
  if (railBuyBtn) {
    railBuyBtn.addEventListener('click', function () {
      var form = document.getElementById('marla-pdp-form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  init();
  updateUI(findVariant());


  // Drawers (sizing guide + enquiry)
  var drawerConfigs = [
    { openSelector: '#marla-pdp-open-sizing', closeId: 'marla-pdp-drawer-close', drawerId: 'marla-pdp-drawer', scrimId: 'marla-pdp-scrim' },
    { openSelector: '[data-open-pdp-enquiry-drawer]', closeId: 'marla-pdp-enquiry-drawer-close', drawerId: 'marla-pdp-enquiry-drawer', scrimId: 'marla-pdp-enquiry-scrim' }
  ];

  drawerConfigs.forEach(function (config) {
    var drawer   = document.getElementById(config.drawerId);
    var scrim    = document.getElementById(config.scrimId);
    var closeBtn = document.getElementById(config.closeId);
    var openers  = document.querySelectorAll(config.openSelector);

    if (!drawer || !scrim) return;

    // Move to <body> so position:fixed works correctly even if the section
    // ancestor gets a CSS transform applied by FoxTheme's scroll animations
    document.body.appendChild(scrim);
    document.body.appendChild(drawer);

    function openDrawer(e) {
      if (e) e.preventDefault();
      drawer.classList.add('marla-pdp__drawer--open');
      scrim.classList.add('marla-pdp__scrim--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('marla-pdp__drawer--open');
      scrim.classList.remove('marla-pdp__scrim--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openers.forEach(function (o) { o.addEventListener('click', openDrawer); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  });

  // Enquiry drawer form submission
  var enquiryForm    = document.getElementById('marla-pdp-enquiry-form');
  var enquiryFields  = document.querySelector('[data-pdp-enquiry-fields]');
  var enquiryFirst   = document.querySelector('[data-pdp-enquiry-first-name]');
  var enquiryEmail   = document.querySelector('[data-pdp-enquiry-email]');
  var enquiryPhone   = document.querySelector('[data-pdp-enquiry-phone]');
  var enquiryMessage = document.querySelector('[data-pdp-enquiry-message]');
  var enquiryProduct = document.querySelector('[data-pdp-enquiry-product-url]');
  var enquirySubmit  = document.querySelector('[data-pdp-enquiry-submit]');
  var enquirySuccess = document.querySelector('[data-pdp-enquiry-success]');
  var enquiryError   = document.querySelector('[data-pdp-enquiry-error]');

  if (enquiryForm) {
    enquiryForm.addEventListener('submit', function (e) {
      e.preventDefault();

      enquirySubmit.disabled = true;
      enquiryError.style.display = 'none';

      grecaptcha.ready(function () {
        grecaptcha.execute('6Lcg-QgtAAAAAAs7oaNx_hh_KZVfPfS2mnvnsOvg', { action: 'product_enquiry' })
          .then(function (token) {
            return fetch('https://marla-form-handler.richard-haruni.workers.dev', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                form_source:         'product_enquiry',
                email:               enquiryEmail.value.trim(),
                first_name:          enquiryFirst.value.trim(),
                phone:               enquiryPhone.value.trim(),
                message:             enquiryMessage.value.trim(),
                product_of_interest: enquiryProduct.value,
                recaptcha_token:     token,
                submission_url:      window.location.href
              })
            });
          })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.success) {
              enquiryFields.style.display = 'none';
              enquirySuccess.style.display = '';
              if (typeof vgo === 'function') {
                vgo('setEmail', enquiryEmail.value.trim());
                vgo('process');
              }
            } else {
              enquiryError.style.display = '';
              enquirySubmit.disabled = false;
            }
          })
          .catch(function () {
            enquiryError.style.display = '';
            enquirySubmit.disabled = false;
          });
      });
    });
  }

})();
